import Aos from "aos";
import { useEffect, useState } from "react";
import mapImg from "../../images/grand-cycle-eau-visuel.jpg";
import img from "../../images/petit_cycle_eau.jpg";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
const CardContentData = [
  {
    id: "1",
    icon: "1",
    title: "ÉVAPORATION ",
    desc: "Chauffée par le soleil, une partie de l’eau des océans, des cours d’eau, des lacs et des zones humides s’évapore et monte dans l’atmosphère sous forme de vapeur d’eau. A ce phénomène s’ajoute l’évapotranspiration des végétaux",
  },

  {
    id: "2",
    icon: "2",
    title: "CONDENSATION",
    desc: "   En altitude, la vapeur d’eau se refroidit et se condense en de fines gouttelettes d’eau qui forment les nuages.",
  },

  {
    id: "3",
    icon: "3",
    title: "PRÉCIPITATION",
    desc: "  Sous l’effet de couches d’air plus froid, les gouttelettes d’eau grossissent. Trop lourdes pour flotter, elles tombent sous forme de précipitations (pluies, neige ou grêle)",
  },
  {
    id: "4",
    icon: "4",

    title: "RUISSELLEMENT",
    desc: "  Une partie de l’eau tombée (24 % des précipitations) ruisselle sur le sol et rejoint les cours d’eau, les étendues d’eau et les mers.",
  },
];

const WaterLifecycle = () => {
  const [message, setMessage] = useState("");

  const handleHover = (city: any) => {
    setMessage(`You hovered over ${city}`);
  };

  const handleMouseLeave = () => {
    setMessage("");
  };

  useEffect(() => {
    Aos.init();
  }, []);
  return (
    <div className="container mx-auto mt-20 mb-20 md:px-40 sm:px-40">
      <div className="font-bold">LE GRAND CYCLE DE L’EAU</div>
      <p className="mt-2 text-justify">
        Depuis près de 4 milliards d’années, la même eau circule entre ciel et
        terre. Au cours de son parcours, elle se transforme et se retrouve dans
        l’air, dans les cours d’eau, sous terre, dans les glaciers et les
        océans. C’est le grand cycle de l’eau avec l’énergie solaire pour
        moteur. Pour renouveler les stocks d’eau douce, chaque étape est
        importante :
      </p>

      <div className="flex flex-col justify-center mt-10 space-y-5 lg:space-y-0 lg:space-x-5 lg:mt-10 lg:flex-row">
        {CardContentData.map((item, index) => (
          <Card
            data-aos="flip-right"
            key={item.id}
            className="hover:bg-[#3CC6F7] group w-full "
          >
            <CardHeader>
              <CardTitle className="flex items-center justify-center">
                <div className="flex items-center justify-center w-[40px] h-[40px] text-black mt-2 rounded-full bg-primary group-hover:text-black group-hover:bg-white">
                  {item.icon}
                </div>
              </CardTitle>
            </CardHeader>
            <CardContent className="flex flex-col items-center justify-center">
              <p className="mt-3 font-bold group-hover:text-white">
                {item.title.charAt(0).toUpperCase() + item.title.slice(1)}
              </p>
              <p className="text-center group-hover:text-white">{item.desc}</p>
            </CardContent>
          </Card>
        ))}
      </div>
      <div className="mt-10">
        <img
          src={mapImg}
          alt=""
          className="w-full rounded-xl "
          onMouseLeave={handleMouseLeave}
        />
      </div>

      <div className="mt-10">
        <div className="font-bold">LE PETIT CYCLE DE L’EAU</div>
        <p className="mt-2 text-justify">
          Depuis près de 4 milliards d’années, la même eau circule entre ciel et
          terre. Au cours de son parcours, elle se transforme et se retrouve
          dans l’air, dans les cours d’eau, sous terre, dans les glaciers et les
          océans. C’est le grand cycle de l’eau avec l’énergie solaire pour
          moteur. Pour renouveler les stocks d’eau douce, chaque étape est
          importante :
        </p>
      </div>
      <div className="flex justify-center mt-10">
        {/* <Cercle /> */}
        <img
          src={img}
          alt=""
          data-aos="zoom-in-up"
          data-aos-duration="3000"
          className="w-[70%]"
        />
      </div>
    </div>
  );
};

export default WaterLifecycle;
